import { ProductExternal } from '@nemuru-eng/js-api-client';

import { MetricsProductExternalModule } from '@/components/modules/Metrics/MetricsProductExternal';
import { OrderListByApplicationTypeModule } from '@/components/modules/OrderList/OrderListByApplicationTypeModule';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES, APP_USER_TYPES } from '@/config/config';
import { ApplicationType, PageScheme } from '@/config/types';

export const PAGE_PAY_BY_LINK_LIST: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.PAY_BY_LINK_LIST,
  showIfAllowedProduct: ApplicationType.PAY_BY_LINK,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'PAY_BY_LINK_LIST',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <MetricsProductExternalModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
          }}
          productExternal={ProductExternal.PAY_BY_LINK}
        />
      ),
    },
    {
      textId: undefined,
      module: (
        <OrderListByApplicationTypeModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
          }}
          applicationType={ApplicationType.PAY_BY_LINK}
        />
      ),
    },
  ],
};
